import React, { useLayoutEffect, useState } from 'react'
import Navbar from '../Navbar'
import { Helmet } from 'react-helmet-async';
import "../pages/About.css"




export const NotFound = () => {


  useLayoutEffect(()=>{

    setTimeout(()=>
    {
       const logo = document.querySelector('.logo a')
      logo.click()

    },3000)
  }, [])


  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://robustik.com/not-found" />
      </Helmet>
      <section className='hero contact' style={{backgroundImage:"unset"}}>
        <div className='container '>
          <div className="flex ">



            <div className="w-full xl:w-1/2  flex justify-center flex-col ">
              <div className="hh1" data-aos="fade-up" data-aos-delay="100"><span className="text-primary font-semibold ">OOPS! 404</span></div>
              <div className="hh4 mt-5" data-aos="fade-up" data-aos-delay="200">Looks like our robot took a wrong turn.</div>
              <p className="m-0" data-aos="fade-up" data-aos-delay="300">The page you're looking for seems to have a malfunctioned or driffed offline. No worries, lets get you back on track.</p>

            </div>

            <div className="w-full xl:w-1/2 relative hidden md:block mt-10 mb-10" data-aos="zoom-in" data-aos-delay="200">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 565.14 317.71">
                <path fill="#ec1c24" d="M391.99,285.47h-218.84c-28.83,0-56.41-8.49-79.77-24.57-17.03-11.71-31.17-27.22-40.91-44.84-10.14-18.34-15.5-39.03-15.5-59.83s5.36-41.49,15.5-59.83c9.74-17.62,23.89-33.12,40.91-44.83,23.36-16.07,50.95-24.57,79.77-24.57h219.18c74.94.17,135.85,58.08,135.85,129.23s-61.09,129.23-136.18,129.23h-.01ZM173.15,58.37c-22.45,0-43.88,6.58-61.99,19.04-26.81,18.45-42.82,47.91-42.82,78.82s16.01,60.38,42.82,78.83c18.11,12.46,39.54,19.04,61.99,19.04h218.84c57.79,0,104.81-43.9,104.81-97.86s-47.02-97.86-104.81-97.86h-218.84Z" />
                <g>
                  <path fill="#ec1c24" d="M153.28,196.52c-3.08,0-6.17-1.13-8.58-3.42-5.02-4.74-5.24-12.65-.5-17.67l18.14-19.19-18.14-19.19c-4.74-5.02-4.52-12.93.5-17.67,5.02-4.74,12.93-4.52,17.67.5l26.26,27.78c4.55,4.82,4.55,12.35,0,17.17l-26.26,27.78c-2.46,2.6-5.77,3.91-9.09,3.91Z" />
                  <path fill="#ec1c24" d="M209.24,196.52c-3.32,0-6.63-1.31-9.09-3.91l-26.26-27.78c-4.55-4.82-4.55-12.35,0-17.17l26.26-27.78c4.74-5.02,12.65-5.24,17.67-.5,5.02,4.74,5.24,12.65.5,17.67l-18.14,19.19,18.14,19.19c4.74,5.02,4.52,12.93-.5,17.67-2.42,2.28-5.5,3.42-8.58,3.42Z" />
                </g>
                <g>
                  <path fill="#ec1c24" d="M355.9,196.52c-3.08,0-6.17-1.13-8.58-3.42-5.02-4.74-5.24-12.65-.5-17.67l18.14-19.19-18.14-19.19c-4.74-5.02-4.52-12.93.5-17.67,5.02-4.74,12.93-4.52,17.67.5l26.26,27.78c4.55,4.82,4.55,12.35,0,17.17l-26.26,27.78c-2.46,2.6-5.77,3.91-9.09,3.91Z" />
                  <path fill="#ec1c24" d="M411.86,196.52c-3.32,0-6.63-1.31-9.09-3.91l-26.25-27.78c-4.55-4.82-4.55-12.35,0-17.17l26.25-27.78c4.74-5.02,12.65-5.24,17.67-.5,5.02,4.74,5.24,12.65.5,17.67l-18.14,19.19,18.14,19.19c4.74,5.02,4.52,12.93-.5,17.67-2.42,2.28-5.5,3.42-8.58,3.42Z" />
                </g>
              </svg>
            </div>



          </div>

        </div>


      </section>


    </>
  )
}

